export default function Hero() {
  return (
    <section
      id="home"
      className="relative h-[100vh] min-h-[720px] w-full overflow-hidden flex items-center justify-center"
    >
      <div className="absolute inset-0 anim-slow-zoom">
        <img
          src="https://static.readdy.ai/image/a35c297e288f6b366b89cee76947f7c3/378eecf4a5ce7023021ac7e3b519ec7f.jpeg"
          alt=""
          className="w-full h-full object-cover object-center"
        />
      </div>


      <div className="relative z-10 w-full max-w-[1240px] px-6 text-center text-background-50 anim-fade-up">
        <h1 className="font-heading text-[44px] sm:text-[64px] md:text-[80px] leading-[1.05] md:leading-[1.08] tracking-[0.02em] md:tracking-[0.04em] font-light text-center w-full">
        時代の寵児、<br className="sm:hidden" />ここに降臨
        </h1>
        <p className="font-heading italic text-2xl md:text-4xl mt-2 text-accent-200">
          — Lamborghini Countach 25th Anniversary Model—
        </p>
        <p className="mt-8 max-w-2xl mx-auto text-sm md:text-base leading-relaxed text-background-50/85">
         商業施設の集客イベント、展示会、PV、映画撮影、<br/>プロポーションなどに。
        </p>
      </div>

      <div className="absolute bottom-10 left-0 right-0 flex flex-col items-center text-background-50/70 anim-fade-in">
        <p className="text-[10px] tracking-[0.4em] uppercase mb-3">Scroll</p>
        <div className="w-px h-12 bg-background-50/40 relative overflow-hidden">
          <span className="absolute top-0 left-0 w-full h-1/2 bg-background-50 anim-fade-in"></span>
        </div>
      </div>
    </section>
  );
}